
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { AppBar } from '../default/appBar/AppBar'
import Drawer from '../default/drawer/Drawer'

/**
 * Layout padrão com AppBar, Drawer e conteúdo com padding
 * @param {React.ReactNode} children - Conteúdo da página
 * @param {string} selectedKey - Chave da seção ativa no Drawer
 */
const Layout = ({ children, selectedKey }) => {

    return (
        <>
            <AppBar />
            <Drawer selectedKey={selectedKey} />

            <Box
                sx={{
                    flexGrow: 1,
                    padding: 2,
                    paddingTop: '64px',
                    transition: 'margin-left 0.3s ease',
                    height: '100vh',
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                {children}
            </Box>
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    selectedKey: PropTypes.string.isRequired
}

export default Layout